//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";
import aos from "~/mixins/aos.js";

export default {
  layout: "default-no-sticky",
  watch: {},
  mixins: [aos],
  data() {
    return {
      showVideo: false,
    };
  },
  methods: {},

  head() {
    if (this.pageInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain + "/careers";
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
        script: [
          {
            type: "text/javascript",
            src: "https://app.polymer.co/embed/embed.min.js",
            jobboard: "legalnature",
            includeCss: true,
            async: true,
            defer: true,
          },
        ],
      };
    } else {
      return {
        script: [
          {
            type: "text/javascript",
            src: "https://app.polymer.co/embed/embed.min.js",
            jobboard: "legalnature",
            includeCss: true,
            async: true,
            defer: true,
          },
        ],
      };
    }
  },

  mounted() {},
  async asyncData({ app, query, params, redirect, error }) {
    let pageInfo = undefined;

    try {
      pageInfo = await API.butterPages.get(app.$axios, "careers", {
        preview: query.preview ? 1 : 0,
      });
    } catch (e) {
      console.error(e);
      error({ message: "Error fetching data..." });

      return {
        loading: false,
      };
    }

    return {
      pageInfo,
      loading: false,
      error: false,
    };
  },
  computed: {
    hero() {
      if (this.pageInfo && this.pageInfo.fields.hero)
        return this.pageInfo.fields.hero.table;
    },
    culture() {
      if (this.pageInfo && this.pageInfo.fields.culture)
        return this.pageInfo.fields.culture.table;
    },
    metaInfo() {
      if (this.pageInfo && this.pageInfo.fields.meta_information)
        return this.pageInfo.fields.meta_information.table;
    },
  },
};
